import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Options from "../../data/options";
import Calculations from "../../helpers/calculations";
import ThreeFields from "./ThreeFields";

const SchuelerDetailsBrandenburg = ({ props }) => {
  const { activeId } = props;
  const schuelerlist = useSelector((st) => st.schueler);
  const schueler = schuelerlist.find((s) => s.id === activeId);
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const calculations = new Calculations(schueler, currentKlausur);
  const {entwurf} = schueler;
  const { sumAfb1Bis3Anteil, abzug, roundedAfb, gesamtnote, gesamtpunkte } =
    calculations.results.Brandenburg;
console.log({entwurf})

    const gesamtbewertung = <Table className="text-right">
    <thead>
      <tr>
        <th>Gesamtbewertung</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      <tr>
        <th>Bereiche</th>
        <th>Punkte</th>
        <th>Ergebnis</th>
        <th>Gesamtpunkte</th>
        <th>Gesamtnote</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Aufgabenbearbeitung</td>
        <td>{sumAfb1Bis3Anteil.toFixed(2)}</td>
        <td>{roundedAfb}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Sprachverwendung</td>
        <td>Abzug</td>

        <td>{abzug}</td>
        <td>{gesamtpunkte}</td>
        <td>{gesamtnote}</td>
      </tr>
    </tbody>
  </Table>


  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Feld</th>
            <th>Wert</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Lese- /Rechtschreibschwierigkeit (nur bei Notenschutz)</td>
            <td>{schueler.leseschwaeche ? "ja" : "nein"}</td>
          </tr>
          <tr>
            <td>Gutachter</td>
            <td>{Options.getValue("gutachter", currentKlausur.gutachter)}</td>
          </tr>
          <tr>
            <td>
              <h4>Aufgabenbearbeitung</h4>
            </td>
          </tr>
          <ThreeFields
            schueler={schueler}
            gewichtung={currentKlausur.prozentAfb1}
            props={props}
            fieldnames={["afb1Points", "afb1Tb", "afb1Remarks"]}
          />
          <ThreeFields
            schueler={schueler}
            klausur={currentKlausur}
            gewichtung={currentKlausur.prozentAfb2}
            props={props}
            fieldnames={["afb2Points", "afb2Tb", "afb2Remarks"]}
          />
          <ThreeFields
            schueler={schueler}
            klausur={currentKlausur}
            gewichtung={currentKlausur.prozentAfb3}
            props={props}
            fieldnames={["afb3Points", "afb3Tb", "afb3Remarks"]}
          />
          <tr>
            <td>
              <h4>Sprachverwendung</h4>
            </td>
          </tr>
          <ThreeFields
            schueler={schueler}
            props={props}
            fieldnames={[
              "spracheKorrektPoints",
              "spracheKorrektTb",
              "spracheKorrektRemarks",
            ]}
          />
          <ThreeFields
            schueler={schueler}
            props={props}
            fieldnames={[
              "spracheAusdruckPoints",
              "spracheAusdruckTb",
              "spracheAusdruckRemarks",
            ]}
          />
          <ThreeFields
            schueler={schueler}
            props={props}
            fieldnames={[
              "spracheLesenPoints",
              "spracheLesenTb",
              "spracheLesenRemarks",
            ]}
          />
          <tr>
            <td>Zusammenfassung</td>
            <td>{schueler.zusammenfassung}</td>
          </tr>
        </tbody>
      </Table>
      <hr></hr>
      <h6>Ergebnisse</h6>
      {entwurf ? <p>Zum Anzeigen der Gesamtbewertung füllen Sie bitte alle Felder aus, und speichern es als Gutachten</p> : gesamtbewertung}
  

    </div>
  );
};
export default SchuelerDetailsBrandenburg;
